// extracted by mini-css-extract-plugin
export var externalLink = "_au-0";
export var internalLinkLabel = "_au-1";